module.exports = __webpack_public_path__ + "img/cardWhite-Back.7cf7f99d.png";